import React from 'react';
import {
    withStyles,
    Grid,
    Typography,
    Avatar,
} from '@material-ui/core';


const ICON1 = require("../../images/icons/1.png");
const ICON2 = require("../../images/icons/2.png");
const ICON3 = require("../../images/icons/3.png");

class AnchorAvatar extends React.Component {

    getIcon(idx) { 
        idx = idx % 3;
        if (idx == 0) {
            return ICON1;
        } else if (idx == 1) {
            return ICON2;
        } else if (idx == 2) {
            return ICON3;
        }
    }

    render() {
        const { classes, idx, avatar, size, imgStyle } = this.props;
        let width = size;
        if (!size) {
            width = 40
        }
        let style = { marginLeft: width / 2, marginTop: width / 2 }
        if (imgStyle) {
            style = imgStyle
        }
        return (
            <Grid container direction='column' justify='center' alignItems='center' style={{ width: width, marginLeft: 8 }}>
                <Grid container direction='column' justify='center' alignItems='center' style={{ width: width }}>
                    <Avatar src={avatar} style={{ width: width, height: width }} />
                    <img src={this.getIcon(idx)} className={classes.subtitle} style={style}></img>
                </Grid>
            </Grid >

        );
    }
}

export default withStyles((theme) => ({
    subtitle: {
        height: 15,
        width: 15,
        zIndex: 1,
        position: 'absolute',
    }

}))(AnchorAvatar);